import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useFetchWithBody, usePost } from '../../api/reactQueryCustomHooks';
import {
    Box, Button, Grid, Paper, Autocomplete,
    TableHead, TableRow, TextField, Typography, FormControl, InputLabel,
    Select, MenuItem, IconButton, InputAdornment, Popover, useMediaQuery, Chip, Alert, AlertTitle, ListSubheader,
    CircularProgress
} from '@mui/material';

import { format, toDate } from 'date-fns';
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory } from '../../constants/enum';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faDownload, faDownLong, faFilter, faInfo, faRefresh, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ErrorCard, LoadingCard, MainContainer, MUIDataTable, NoDataCard } from '../../components';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { head } from 'lodash';
import { toast } from 'react-toastify';

export const ALL_COLUMNS = {

    Party: { label: "Party", group: "party", type: "string" },
    Broker: { label: "Broker", group: "broker", type: "string" },
    invDate: { label: "Inv. Date", group: "none", type: "date" },
    voutype: { label: "Bill Type", group: "none", type: "string" },
    invno: { label: "Inv.No", group: "none", type: "string" },
    DueDays: { label: "Due Days", group: "none", type: "string" },
    DueDate: { label: "Due Date", group: "none", type: "date" },
    invAmt: { label: "Inv.Amount", group: "none", type: "number" },
    TdsAmt: { label: "TDS Amount", group: "none", type: "number" },
    PayAmt: { label: "Pay Amount", group: "none", type: "number" },
    retAmt: { label: "Ret.Amount", group: "none", type: "number" },
    BalanceAmt: { label: "Balance Amount", group: "none", type: "number" },
    dif_day_inv_date: { label: "Diff.Days Inv.Date", group: "none", type: "string" },
    dif_day_due_date: { label: "Diff.Days Due.Date", group: "none", type: "string" },


};

export const getColumns = (groupBy, activeTab, useMktAsMfg = true) => {
    return Object.entries(ALL_COLUMNS)
        .filter(([key, col]) => {
            // Handle SL_Code
            const bothgroup = ['invAmt', 'TdsAmt', 'PayAmt', 'retAmt', 'BalanceAmt']
            if (bothgroup.includes(key))
                return groupBy === "none" || groupBy === "party" || groupBy === "broker";
            if (key === "Party") {
                return groupBy === "none" || groupBy === "party";
            }

            if (key === "Broker") {
                return groupBy === "none" || groupBy === "broker";
            }

            // Handle grouped columns
            if (col.group && col.group !== groupBy) return false;


            return true;
        })
        .map(([key, col]) => ({ key, ...col }));
};
;


const OutstandingReport = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [tabValue, setTabValue] = useState(0);
    const [activeTab, setActiveTab] = useState('all');
    const { compCode, compName, startDate, endDate } = useSelector((state) => state.company);
    const tableRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentFilterColumn, setCurrentFilterColumn] = useState('');
    const [showReport, setShowReport] = useState(false);
    const [groupBy, setGroupBy] = useState('none');
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
    const [filterField, setFilterField] = useState('invDate');
    const [reportData, setReportData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [columnFilters, setColumnFilters] = useState({
        Party: '',
        invDate: '',
        voutype: '',
        invno: '',
        DueDays: '',
        DueDate: '',
        invAmt: '',
        TdsAmt: '',
        PayAmt: '',
        retAmt: '',
        BalanceAmt: '',
        dif_day_inv_date: '',
        dif_day_due_date: '',
        Broker: ''
    });

    const [filters, setFilters] = useState({
        out_type: 'R',
        party_id: '',
        party_name: '',
        diff_duedate: new Date(),
        showAge1: 0,
        showAge2: 0,
        compcode: compCode,
        fromDate: dayjs(startDate).format("YYYY-MM-DD"),// startDate.split('T')[0],
        toDate: dayjs(endDate).format("YYYY-MM-DD"),//endDate.split('T')[0]//new Date()
    });

    const exportColumnKeys = [
        "Party",
        "invDate",
        "voutype",
        "invno",
        "DueDays",
        "DueDate",
        "invAmt",
        "TdsAmt",
        "PayAmt",
        "retAmt",
        "BalanceAmt",
        "dif_day_inv_date",
        "dif_day_due_date",
        "Broker"
    ];

    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingInwardItem",
        inputData: {
            mod_name: ENUM_MOD_NAME.GeneralSettings
        }
    })
    useEffect(() => {
        if (modSetting && modSetting.length > 0) {
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
            setIsUseMfgNoAsMktno(mktSetting)
        }
    }, [modSetting])

    const {
        isLoading,
        data: accountsData = [],
        isError: isAccountsError,
        error: accountsError,
    } = useFetchWithBody({
        url: apiRoute.outstanding.getAccount,
        queryKey: ['accounts'],
        inputData: {},
    });

    // const filteredAccounts = accountsData.filter(account =>
    //     account.AC_DESC.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     account.AC_ID.toString().includes(searchTerm)
    // );

    const {
        mutate: fetchReport,
        isPending,
        isError,
        data
    } = usePost({
        url: apiRoute.outstanding.getReportData,
        queryKey: 'partyDetails',
        onSuccessTasks: (data) => {
            const formattedData = data.map(item => ({
                Party: item.party || '',
                invDate: item.inv_date,
                voutype: item.vou_type || '',
                invno: item.inv_no || '',
                DueDays: item.duedays || 0,
                DueDate: item.duedate,
                invAmt: parseFloat(item.inv_amount) || 0,
                TdsAmt: parseFloat(item.tds_amount) || 0,
                PayAmt: parseFloat(item.pay_amount) || 0,
                retAmt: parseFloat(item.ret_amount) || 0,
                BalanceAmt: parseFloat(item.balance_amount) || 0,
                dif_day_inv_date: item.diff_days_inv_date || 0,
                dif_day_due_date: item.diff_days_due_date || 0,
                Broker: item.broker || ''
            }));
            setReportData(formattedData);
            // setFilteredData(formattedData);
            setShowReport(true);
            // // setFromDate(null);
            // // setToDate(null);
            // setFilterField('inv_date');
        },
    });
    console.log(filters)



    // Apply column filters to the data
    const filteredData = useMemo(() => {
        if (!reportData.length) return [];
        return reportData.filter(row => {
            return Object.entries(columnFilters).every(([key, value]) => {
                if (!value) return true;
                const rowValue = row[key] || '';
                return String(rowValue).toLowerCase().includes(String(value).toLowerCase());
            });
        });
    }, [reportData, columnFilters]);




    const filteredAndGroupedData = useMemo(() => {
        if (!reportData?.length) return [];

        /* ================= FILTER (COLUMN) ================= */
        let data = filteredData;
        // let data = reportData.filter(row =>
        //     Object.entries(columnFilters).every(([key, value]) => {
        //         if (!value) return true;
        //         return String(row[key] ?? '')
        //             .toLowerCase()
        //             .includes(String(value).toLowerCase());
        //     })
        // );

        /* ================= FILTER (DATE RANGE) ================= */

        if (filters?.fromDate || filters?.toDate) {
            data = filteredData.filter(item => {
                const dateStr = item[filterField === 'invDate' ? 'invDate' : 'DueDate'];
                if (!dateStr) return false;

                const [day, month, year] = dateStr.split('-');
                const date = new Date(`${year}-${month}-${day}`);

                if (filters?.fromDate && date < filters?.fromDate) return false;
                if (filters?.toDate && date > filters?.toDate) return false;

                return true;
            });
        }

        /* ================= NO GROUPING ================= */

        if (groupBy === 'none') return data;

        /* ================= GROUPING ================= */

        const groupedData = {};

        const getGroupKey = (row) => {
            switch (groupBy) {
                case 'broker':
                    return row.Broker || 'Unknown Broker';
                case 'party':
                    return row.Party || 'Unknown Party';
                default:
                    return 'all';
            }
        };

        const initGroup = (row, key) => ({
            groupKey: key,
            Broker: groupBy === 'broker' ? row.Broker : 'Multiple Brokers',
            Party: groupBy === 'party' ? row.Party : 'Multiple Parties',
            invDate: 0,
            DueDays: 0,
            invAmt: 0,
            TdsAmt: 0,
            PayAmt: 0,
            retAmt: 0,
            BalanceAmt: 0,
            dif_day_inv_date: 0,
            dif_day_due_date: 0,

            // weighted helpers
            //  _rateWeightedSum: 0,
            //  _weightSum: 0,

            _children: []
        });

        data.forEach(row => {
            const key = getGroupKey(row);

            if (!groupedData[key]) {
                groupedData[key] = initGroup(row, key);
            }

            const group = groupedData[key];

            const add = (field) => {
                group[field] += Number(row[field]) || 0;
            };

            add('DueDays');
            add('invAmt');
            add('TdsAmt');
            add('PayAmt');
            add('retAmt');
            add('BalanceAmt');
            add('dif_day_inv_date');
            add('dif_day_due_date');

            // Example weighted logic (if needed)
            // if (row.Rate && row.Weight) {
            //     group._rateWeightedSum += Number(row.Rate) * Number(row.Weight);
            //     group._weightSum += Number(row.Weight);
            // }

            group._children.push(row);
        });

        /* ================= FINALIZE ================= */

        return Object.values(groupedData)
            .map(({ _rateWeightedSum, _weightSum, ...rest }) => ({
                ...rest,
                Rate: _weightSum ? _rateWeightedSum / _weightSum : 0
            }))
            .sort((a, b) =>
                String(a.groupKey).localeCompare(String(b.groupKey))
            );

    }, [
        filteredData,
        columnFilters,
        filters,
        filterField,
        groupBy
    ]);





    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };



    // const handleTabChange = (event, newValue) => {
    //   setTabValue(newValue);
    //   setFilters(prev => ({ ...prev, isSummary: newValue === 1 }));
    // };ry

    const filteredAccounts = accountsData.filter(account =>
        account.AC_DESC.toLowerCase().includes(searchTerm.toLowerCase()) ||
        account.AC_ID.toString().includes(searchTerm)
    );
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handlePartyChange = (event, value) => {
        setFilters(prev => ({
            ...prev,
            party_id: value ? value.AC_ID : '',
            party_name: value ? value.AC_DESC : ''
        }));
    };

    const handleDateChange = (date) => {
        setFilters((prev) => ({ ...prev, diff_duedate: date }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if ((filters.fromDate && filters.fromDate == 'Invalid Date')
            || (filters.toDate && filters.toDate == 'Invalid Date')) {
            toast.error("Invalid From Date / To Date", {
                "position": "top-center"
            })
        }
        else {
            setShowReport(false);
            const formattedData = {
                ...filters,
                diff_duedate: format(filters.diff_duedate, 'yyyy-MM-dd'),
                compcode: compCode,
                date_type: filterField
            };
            fetchReport({ data: formattedData });
        }

        // refetch();
    };

    const handleReset = () => {
        setFilters({
            out_type: 'R',
            party_id: '',
            party_name: '',
            diff_duedate: new Date(),
            showAge1: 0,
            showAge2: 0,
            compcode: compCode,
            fromDate: dayjs(startDate).format("YYYY-MM-DD"),// startDate.split('T')[0],
            toDate: dayjs(endDate).format("YYYY-MM-DD")// startDate.split('T')[0],
        });
        setFilterField("invDate")
        const params = {
            out_type: 'R',
            party_id: '',
            party_name: '',
            diff_duedate: new Date(),
            showAge1: 0,
            showAge2: 0,
            compcode: compCode,
            diff_duedate: format(filters.diff_duedate, 'yyyy-MM-dd'),
            compcode: compCode,
            fromDate: null,
            toDate: null
        };
        fetchReport({ data: params });
    };



    const calculateTotals = () => {
        const totals = {
            invAmt: 0,
            TdsAmt: 0,
            PayAmt: 0,
            retAmt: 0,
            BalanceAmt: 0
        };

        filteredData.forEach(row => {
            totals.invAmt += parseFloat(row.invAmt) || 0;
            totals.TdsAmt += parseFloat(row.TdsAmt) || 0;
            totals.PayAmt += parseFloat(row.PayAmt) || 0;
            totals.retAmt += parseFloat(row.retAmt) || 0;
            totals.BalanceAmt += parseFloat(row.BalanceAmt) || 0;
        });

        return totals;
    };


    const totals = calculateTotals();

    const getReportTitle = () => {
        return filters.out_type === 'R' ? 'Receivable Outstanding Report' : 'Payable Outstanding Report';
    };



    const safeDate = (val) => {
        const d = dayjs(val);
        return d.isValid() ? d : null;
    };


    const headCssStyle = { fontSize: "0.7rem", lineHeight: 1.3, textTransform: "uppercase", backgroundColor: '#f0f0f0', fontWeight: 600, color: '#3c3c3c' }
    const columns = useMemo(() => getColumns(groupBy, activeTab, isUseMfgNoAsMktno), [isUseMfgNoAsMktno, groupBy]);
    if (isError) {
        return <ErrorCard />
    }
    if (isLoading) {
        return <LoadingCard />
    }
    return (
        <MainContainer
            pageName={`Oustanding Report`}
            breadcrumbs={["Reports", "Outstanding Report"]}
        >
            <Box sx={{
                p: isMobile ? 1 : 3,
                backgroundColor: 'background.default',
                minHeight: '100vh',

            }}>
                {/* Header Section */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', md: 'center' },
                    gap: 2,
                    mb: 1,
                    p: 1,
                    backgroundColor: 'background.paper',
                    borderRadius: 3,
                    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.08)'
                }}>
                    <Typography variant="h4" sx={{
                        fontSize: isMobile ? '1rem' : '1.3rem',
                        fontWeight: 400,
                        color: 'primary.main',
                        letterSpacing: -0.5
                    }}>
                        {getReportTitle()}
                    </Typography>

                    {reportData.length > 0 && (
                        <Box sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1,
                            alignSelf: { xs: 'stretch', md: 'center' }
                        }}>
                            {/* <Button
                variant="contained"
                color="success"
                startIcon={<FontAwesomeIcon icon={faDownload} />}
                onClick={exportToExcel}
                disabled={filteredData.length === 0}
                sx={{
                  textTransform: 'none',
                  fontWeight: 500,
                  px: 3,
                  borderRadius: 2,
                  fontSize: "0.8rem",
                  boxShadow: 'none',
                  '&:hover': { boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)' }
                }}
              >
                Export Excel
              </Button>

              <Button
                variant="contained"
                color="error"
                startIcon={<FontAwesomeIcon icon={faDownLong} />}
                onClick={exportToPDF}
                disabled={filteredData.length === 0}
                sx={{
                  textTransform: 'none',
                  fontWeight: 500,
                  px: 3,
                  borderRadius: 2,
                  fontSize: "0.8rem",
                  boxShadow: 'none',
                  '&:hover': { boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)' }
                }}
              >
                Export PDF
              </Button> */}
                        </Box>
                    )}
                </Box>

                {/* Filters Section */}
                <Paper sx={{
                    p: 2,
                    mb: 1,
                    borderRadius: 2,
                    boxShadow: 1,
                    backgroundColor: 'background.paper'
                }}>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} alignItems="center">
                            {/* Primary Filters */}
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Type</InputLabel>
                                    <Select
                                        name="out_type"
                                        value={filters.out_type}
                                        onChange={handleChange}
                                        label="Type"
                                    >
                                        <MenuItem value="R">Receivable</MenuItem>
                                        <MenuItem value="G">Payable</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Autocomplete
                                    options={filteredAccounts}
                                    getOptionLabel={(option) => option.AC_DESC}
                                    value={accountsData.find(account => account.AC_ID === filters.party_id) || null}
                                    onChange={handlePartyChange}
                                    // onInputChange={(e, v) => setSearchTerm(v)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Search Party"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {isLoading && <CircularProgress size={20} />}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                    loading={isLoading}
                                    noOptionsText="No parties found"
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <FormControl fullWidth size="small">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={"As On Date"}
                                            views={["day", "month", "year"]}
                                            format="DD/MM/YYYY"
                                            value={
                                                filters.diff_duedate
                                                    ? dayjs(filters.diff_duedate)
                                                    : filters.diff_duedate
                                            }
                                            onChange={(newValue) => {
                                                setFilters((prev) => {
                                                    return {
                                                        ...prev,
                                                        diff_duedate: newValue != '' && newValue != 'Invalid Date' ?
                                                            dayjs(newValue).format("YYYY-MM-DD") : null,
                                                    };
                                                });
                                            }}
                                            //isRequired={item.required}
                                            // className="w-full "
                                            slotProps={{
                                                textField: { size: "small", },
                                            }}
                                        />
                                    </LocalizationProvider>

                                </FormControl>
                            </Grid>

                            {/* Secondary Filters - Disabled initially */}
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <FormControl fullWidth size="small" disabled={!showReport}>
                                    <InputLabel>Filter By</InputLabel>
                                    <Select
                                        value={filterField}
                                        label="Filter By"
                                        onChange={(e) => setFilterField(e.target.value)}
                                    >
                                        <MenuItem value="invDate">Invoice Date</MenuItem>
                                        <MenuItem value="DueDate">Due Date</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={"From Date"}
                                            views={["day", "month", "year"]}
                                            format="DD/MM/YYYY"
                                            value={safeDate(
                                                filters.fromDate
                                                    ? dayjs(filters.fromDate)
                                                    : filters.fromDate)
                                            }
                                            onChange={(newValue) => {
                                                setFilters((prev) => {
                                                    return {
                                                        ...prev,
                                                        fromDate: newValue != '' && newValue != 'Invalid Date' ?
                                                            dayjs(newValue).format("YYYY-MM-DD") : null,
                                                    };
                                                });
                                            }}
                                            slotProps={{
                                                textField: { size: "small", },
                                            }}
                                        />
                                    </LocalizationProvider>

                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={"To Date"}
                                            views={["day", "month", "year"]}
                                            format="DD/MM/YYYY"
                                            value={
                                                filters.toDate
                                                    ? dayjs(filters.toDate)
                                                    : filters.toDate
                                            }
                                            onChange={(newValue) => {
                                                setFilters((prev) => {
                                                    return {
                                                        ...prev,
                                                        toDate: newValue != '' && newValue != 'Invalid Date' ?
                                                            dayjs(newValue).format("YYYY-MM-DD") : null,
                                                    };
                                                });
                                            }}
                                            slotProps={{
                                                textField: { size: "small", },
                                            }}
                                        />
                                    </LocalizationProvider>

                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <FormControl fullWidth size="small" disabled={!showReport}>
                                    <InputLabel>Order By</InputLabel>
                                    <Select
                                        label="Group By"
                                        value={groupBy}
                                        onChange={(e) => setGroupBy(e.target.value)}
                                    >
                                        <ListSubheader>Detail :</ListSubheader>
                                        <MenuItem value="none">Report Detail</MenuItem>
                                        <ListSubheader>Summary :</ListSubheader>
                                        <MenuItem value="party">Party</MenuItem>
                                        <MenuItem value="broker">Broker</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Action Buttons - Always at the end */}
                            <Grid item xs={12} sm={6} md={3} lg={2}>
                                <Box sx={{
                                    display: 'flex',
                                    gap: 1.5,
                                    flexDirection: { xs: 'row', sm: 'row-reverse' },
                                    justifyContent: { xs: 'flex-start', sm: 'flex-end' }
                                }}>


                                    <Button
                                        variant="outlined"
                                        onClick={handleReset}
                                        startIcon={<FontAwesomeIcon style={{ fontSize: "0.9rem" }} icon={faRefresh} />}
                                        sx={{
                                            minWidth: 100,
                                            // py: 1,
                                            borderRadius: 2,
                                            fontWeight: 500,
                                            textTransform: 'none',
                                            borderWidth: 1.5,
                                            '&:hover': { borderWidth: 1.5 },
                                            flexGrow: { xs: 1, sm: 0 }
                                        }}
                                    >
                                        Reset
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        disabled={isPending}
                                        startIcon={isPending ? <CircularProgress size={20} color="inherit" /> :
                                            <FontAwesomeIcon style={{ fontSize: "0.9rem" }} icon={faSearch} />
                                        }
                                        sx={{
                                            minWidth: 100,
                                            // py: 0,
                                            borderRadius: 2,
                                            fontWeight: 500,
                                            textTransform: 'none',
                                            flexGrow: { xs: 1, sm: 0 }
                                        }}
                                    >
                                        {isPending ? 'Searching' : 'Search'}
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </Paper>


                {/* Error Message */}


                {/* Data Table Section */}
                <Paper sx={{
                    p: isMobile ? 1 : 1,
                    borderRadius: 3,
                    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.08)',
                    backgroundColor: 'background.paper'
                }} ref={tableRef}>
                    {/* Table Header */}


                    {/* Data Table */}
                    {reportData.length > 0 ? (
                        <Box sx={{ width: "100%", overflowX: "auto" }}>
                            <MUIDataTable
                                data={filteredAndGroupedData}
                                dataColumns={columns}
                                reportTitle={`${filters.out_type === 'R' ? 'Receivable' : 'Payable'} Outstanding Report`}
                                orderGroup={groupBy}
                                enableCurrency={false}
                                filterDate={filters}
                                tradeLabel={`Type: ${filters.out_type === 'R' ? 'Receivable' : 'Payable'} `}
                                companyName={compName.join(",")}
                                hideIfZeroKeys={["TDSAmt", "DiscAmt", "DiscPer", "GSTAmt"]}
                                exportColumnKeys={exportColumnKeys}
                                enableHeaderFilter={true}

                            />
                        </Box>
                    ) : (
                        !isPending && (
                            <NoDataCard/>
                        )
                    )}
                </Paper>


            </Box>
        </MainContainer>
    );
};

export default OutstandingReport;
